import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getPortinLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const VSPortinHistory = (props) => {
  const [portinHistory, setPortinHistory] = useState([]);
  const { portin_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getPortinLog(portin_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setPortinHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Portin Log
        </Typography>
      </Box>

      {response && portinHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">ICCID</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Name</TableCell>
                    <TableCell align="left">Account Number</TableCell>
                    <TableCell align="left">Street</TableCell>
                    <TableCell align="left">City</TableCell>
                    <TableCell align="left">State</TableCell>
                    <TableCell align="left">Zipcode</TableCell>
                    <TableCell align="left">MSISDN</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {portinHistory.data.iccid}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/vs/portin/batch/${portinHistory.data.batch_id}`}
                      >
                        {portinHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={portinHistory.data.status}
                        size="small"
                        color={getChipColor(portinHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {portinHistory.data.name}
                    </TableCell>
                    <TableCell align="left">
                      {portinHistory.data.account_number}
                    </TableCell>
                    <TableCell align="left">
                      {portinHistory.data.street}
                    </TableCell>
                    <TableCell align="left">
                      {portinHistory.data.city}
                    </TableCell>
                    <TableCell align="left">
                      {portinHistory.data.state}
                    </TableCell>
                    <TableCell align="left">
                      {portinHistory.data.zipcode}
                    </TableCell>
                    <TableCell align="left">
                      {portinHistory.data.msisdn}
                    </TableCell>
                    <TableCell align="left">
                      {portinHistory.data.last_updated &&
                        `${format(
                          new Date(portinHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={portinHistory.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default VSPortinHistory;
